import { defineMessage } from 'react-intl'

export const TryOnceMoreMsg = defineMessage({ description: 'App.General.TryOnceMore', defaultMessage: 'Please, try it once more or contact us by { email }' })